import { render } from "./App.vue?vue&type=template&id=caaf0688"
const script = {}

import "./App.vue?vue&type=style&index=0&id=caaf0688&lang=scss"
script.render = render

export default script